'use strict';

module.exports = require('./Switch');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-switch/lib/index.js
 ** module id = 726
 ** module chunks = 0
 **/